const eventModalMixin = {
  data() {
    return {
      eventDetailModalParams: null,
      eventDetailModalOpen: false,
      eventEditModalOpen: false
    };
  },
  methods: {
    openEventDetailModal() {
      this.eventDetailModalOpen = true;
    },
    closeEventDetailModal() {
      this.eventDetailModalOpen = false;
      this.resetEventModalParams();
    },
    openEventEditModal() {
      this.eventEditModalOpen = true;
    },
    closeEventEditModal() {
      this.eventEditModalOpen = false;
    },
    setEventModalParams(eventPolicyId, productTypeCode, projectId) {
      let params = {
        eventPolicyId: eventPolicyId,
        resourceType: productTypeCode
      }

      if (projectId) {
        params.projectId = projectId
      }

      this.eventDetailModalParams = params;
    },
    resetEventModalParams() {
      this.eventDetailModalParams = null;
    }
  }
};

export default eventModalMixin;
